import React from 'react';

import ReactMarkdown, { ReactMarkdownOptions } from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

interface MarkdownProps extends ReactMarkdownOptions {
  text?: string;
  segment?: boolean;
}

const Markdown = ({
  segment,
  text,
  ...otherProps
}: Omit<MarkdownProps, 'children'>) => (
  <ReactMarkdown
    {...otherProps}
    rehypePlugins={[rehypeRaw]}
    remarkPlugins={[gfm]}
  >
    {segment ? text?.replace(/\n/gi, '<br/>') || '' : text || ''}
  </ReactMarkdown>
);

export default Markdown;
